module.exports = __webpack_public_path__ + "img/main.md.edef5642.png";